import { createAction } from '../store.model';

import { RepCardActions } from './enums/card-actions.enum';
import { RepCard } from './models/rep-card.model';
import { SortColumn, SortDirection } from './models/sort-event-model';

export enum ActionType {
    COACHING_CARD_REP__ROOT__RELOAD = 'COACHING_CARD_REP__ROOT__RELOAD',
    COACHING_CARD_REP__ROOT__RELOAD_RESULT = 'COACHING_CARD_REP__ROOT__RELOAD_RESULT',
    COACHING_CARD_REP__ROOT__SORT_BY_COLUMN = 'COACHING_CARD_REP__ROOT__SORT_BY_COLUMN',
    COACHING_CARD_REP__ROOT__REP_CARD_ACTIONS = 'COACHING_CARD_REP__ROOT__REP_CARD_ACTIONS',
    COACHING_CARD_REP_ROOT__CLEAR_STATE = 'COACHING_CARD_REP_ROOT__CLEAR_STATE',
}

export interface Reload {
    userId?: number;
    periodTypeId?: number;
}

export const reload = createAction<ActionType, Reload>(
    ActionType.COACHING_CARD_REP__ROOT__RELOAD,
);

export interface ReloadResult extends Reload {
    card?: RepCard;
}

export const reloadResult = createAction<ActionType, ReloadResult>(
    ActionType.COACHING_CARD_REP__ROOT__RELOAD_RESULT,
);
export interface SortByColumn {
    index?: number;
    column?: SortColumn;
    direction?: SortDirection;
}

export const sortByColumn = createAction<ActionType, SortByColumn>(
    ActionType.COACHING_CARD_REP__ROOT__SORT_BY_COLUMN,
);
export interface RepCardAction {
    actionType?: RepCardActions;
    index?: number;
}

export const repCardActions = createAction<ActionType, RepCardAction>(
    ActionType.COACHING_CARD_REP__ROOT__REP_CARD_ACTIONS,
);

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface RootClearStateAction {}

export const clearState = createAction<ActionType, RootClearStateAction>(
    ActionType.COACHING_CARD_REP_ROOT__CLEAR_STATE,
);
